import React from 'react';
import useClock from './clockData';
import './clock.css'

function Clock() {
    const timeNow = useClock();
    return (
        <div className='cover-clock'>
            <p className='clockTitle'>Time is our only limitation.</p>
            <p className="clock">{timeNow}</p>
        </div>
    );
}

export default Clock;